import { fetcher } from '@commenda/utils';

export async function duplicateQuote(
  affiliateFirmId: string,
  quoteId: string
): Promise<Response | null> {
  try {
    const res = await fetcher(
      `affiliate-firms/${affiliateFirmId}/quotes/${quoteId}/duplicateQuote`,
      {
        method: 'POST',
      }
    );


    return res;
  } catch (err) {
    console.error(err);
    return null;
  }
}
